<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">
            <el-form-item label="分销员">
                <el-select v-model="formInline.distributorId" clearable filterable placeholder="分销员">
                    <el-option v-for="item in distributorData"
                               :key="item.id"
                               :label="item.distributorPhone+'('+item.distributorName+')'"
                               :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="客户手机号">
                <el-input v-model="formInline.mobile" placeholder="客户手机号"></el-input>
            </el-form-item>
            <el-form-item label="客户昵称">
                <el-input v-model="formInline.nickName" placeholder="客户昵称"></el-input>
            </el-form-item>
            <el-form-item label="子单号">
            <el-input v-model="formInline.orderNo" placeholder="子单号"></el-input>
            </el-form-item>
            <el-form-item label="日期范围">
                <el-date-picker
                        v-model="dates"
                        type="daterange"
                        align="right"
                        unlink-panels
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="是否有效">
                <el-select v-model="formInline.status"  filterable placeholder="是否有效">
                    <el-option v-for="item in statusData"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="getList">查询</el-button>
        </el-form-item>
        </el-form>


        <el-table :data="listData" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading" >
              <!--  <el-table-column type="selection" width="55"></el-table-column>-->
                <el-table-column type="index" label="序号" width="50"></el-table-column>

                <el-table-column prop="distributorName" label="分销员姓名" ></el-table-column>
                <el-table-column prop="distributorPhone" label="分销员电话" ></el-table-column>
                <el-table-column prop="nickName" label="客户昵称" ></el-table-column>
                <el-table-column prop="status" label="是否有效" :formatter="statusShow"  ></el-table-column>
                <el-table-column prop="createTime" label="创建日期" ></el-table-column>
                <el-table-column prop="orderNo" label="订单号" ></el-table-column>
                <el-table-column prop="saleAmount" label="销售金额" ></el-table-column>
                <el-table-column prop="expectOrderAmount" label="预计订单金额" ></el-table-column>
<!--                <el-table-column prop="expectPercentageAmount" label="预计提成金额" ></el-table-column>-->
                <el-table-column prop="finalOrderAmount" label="最终订单金额" ></el-table-column>
                <el-table-column prop="finalPercentageAmount" label="最终提成金额" ></el-table-column>
                <el-table-column prop="hasSettledName" label="结算状态" ></el-table-column>
                <el-table-column prop="diffReason" label="差异原因" ></el-table-column>

            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="formInline.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="formInline.recordsTotal">
                </el-pagination>
            </div>

    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getDistributionOrderPageList,getDistributorOption} from '../../api/api';
    import uploadComponents from '@/components/upload';

    //定义组件
    export default{
        data(){
            return {
                dates:[],
                listData:[],
                distributorData:[],
                statusData:[{"id":0,"name":"否"},{"id":1,"name":"是"},{"id":null,"name":"全部"}],
                loading:true,
                dialogFormVisible:false,
                form:{"id":null,"distributorPhone":"","distributorName":"","mobile":""},
                formInline:{
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                    status:1,
                    distributorId:null,
                    sdate:null,
                    edate:null,
                },
                platformDisabled:false,
                pickerOptions: {

                    shortcuts: [{
                        text: '今天',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            //start.setTime(start.getTime());
                            picker.$emit('pick', [start, end]);
                        }
                    },{
                        text: '昨天',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                            end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
                            picker.$emit('pick', [start, end]);
                        }
                    },{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
            }
        },
        //挂载时候执行
        mounted(){
            getDistributorOption(this.formInline).then((res) => {
                this.distributorData=res.data.value;
                this.formInline.distributorId=this.$route.query.distributorId;
                if(this.formInline.distributorId==null){
                    this.formInline.distributorId=res.data.value[0].id;
                }
               this.dates.push(new Date((new Date()- 3600 * 1000 * 24 * 30)).toISOString().substring(0,10));
               this.dates.push(new Date().toISOString().substring(0,10));


                //初始化首页数据
                this.getList();
            });

        },
        components:{
            uploadComponents
        },
        methods:{
            //定义查询方法
            getList(){
                console.log(this.dates);
                if(this.dates!=null){
                    this.formInline.sdate=this.dates[0];
                    this.formInline.edate=this.dates[1];
                }else{
                    this.formInline.sdate=null;
                    this.formInline.edate=null;
                }

                getDistributionOrderPageList(this.formInline).then((res) => {
                    this.loading = false;
                    this.formInline.recordsTotal = res.data.value.total;
                    this.listData = res.data.value.list;

                })
            },
            statusShow(row, column, cellValue) {
                for(var key in this.statusData){
                    if(this.statusData[key].id==cellValue) {
                        return this.statusData[key].name;
                    }
                }
                //return this.randData.name;

            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
        },

    }

</script>



// WEBPACK FOOTER //
// src/views/distribution/distributionOrder.vue